/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import {
  addJob, deleteJob, fetchJobs, fetchUserJobs, JobInfo, removeJob, updateJob,
} from '../thunks/jobThunks.ts';

interface JobsState {
jobs: JobInfo[],
userJobs: JobInfo[],
loading: boolean,
error: string | null,
success: boolean,
}

const initialState: JobsState = {
  jobs: [],
  loading: false,
  error: null,
  success: false,
  userJobs: [],
};

const jobSlice = createSlice({
  name: 'job',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchJobs.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchJobs.fulfilled, (state, action) => {
      state.loading = false;
      state.jobs = [...action.payload].reverse();
      state.error = null;
    });
    builder.addCase(fetchJobs.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || 'Failed to load jobs';
    });
    builder.addCase(addJob.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(addJob.fulfilled, (state, action) => {
      state.loading = false;
      state.jobs = [action.payload.data, ...state.jobs];
      state.error = null;
    });
    builder.addCase(addJob.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || 'Failed to add job';
    });
    builder.addCase(deleteJob.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteJob.fulfilled, (state, action) => {
      state.loading = false;
      state.jobs = state.jobs.filter((job) => job._id as any !== action.payload);
      state.error = null;
    });
    builder.addCase(deleteJob.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || 'Failed to delete job';
    });
    builder.addCase(updateJob.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(updateJob.fulfilled, (state, action) => {
      state.loading = false;
      // eslint-disable-next-line no-confusing-arrow
      state.jobs = state.jobs.map((job) => job._id === action.payload._id ? action.payload : job);
      state.error = null;
    });
    builder.addCase(updateJob.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || 'Failed to update job';
    });

       // Handle removeJob thunk
       builder.addCase(removeJob.pending, (state) => {
        state.loading = true;
        state.error = null;
      });
      builder.addCase(removeJob.fulfilled, (state, action) => {
        state.loading = false;
        state.jobs = state.jobs.filter((job) => job._id !== action.payload);
        state.error = null;
        state.success = true;
      });
      builder.addCase(removeJob.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.success = false;
      });

    // fetchuserjobs
    builder.addCase(fetchUserJobs.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchUserJobs.fulfilled, (state, action) => {
      state.loading = false;
      state.userJobs = action.payload;
      state.error = null;
    });
    builder.addCase(fetchUserJobs.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || 'Failed to fetch user jobs';
    });
  },
});

const jobsReducer = jobSlice.reducer;
export default jobsReducer;
